export default __webpack_public_path__ + "static/maths-1c0ee760cd27db830e3baa848159a401.mp4";